<template>
  <div style="border: 1px solid #ccc" :style="{width: width}">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor class="editor"  v-model="editorValue" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Editor, Toolbar, IToolbarConfig } from '@wangeditor/editor-for-vue'
  const toolbarConfig = {}
  export default Vue.extend({
    components: { Editor, Toolbar },
    props: {
      value: {
        type: [String, Number, Array, Object],
        default: '',
      },
      width:{
        type:[String,Number],
        default:'100%'
      }
    },
    data() {
      return {
        editor: null,
        html: '',
        toolbarConfig: {},
        editorConfig: {
          placeholder: '请输入内容...',
          // autoFocus: false,
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            uploadImage: {
              // 后端上传地址，必填
              server: process.env.VUE_APP_API_URL + '/admin/upload/image',
              // form-data fieldName，后端接口参数名称，默认值wangeditor-uploaded-image
              fieldName: 'image',
              // 1M，单个文件的最大体积限制，默认为 2M
              maxFileSize: 30 * 1024 * 1024,
              // 最多可上传几个文件，默认为 100
              maxNumberOfFiles: 10,
              // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
              allowedFileTypes: ['image/*'],
              // 15 秒，超时时间，默认为 10 秒
              timeout: 30 * 1000,
              // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
              headers: {
                authorization: localStorage.getItem('token'),
              },
              customInsert(res, insertFn) {
                if (res.code == 0) {
                  insertFn(res.data.url)
                }
              },
            },
            uploadVideo: {
              // 后端上传地址，必填
              server: '/admin/upload/video',
              // form-data fieldName，后端接口参数名称，默认值wangeditor-uploaded-video
              fieldName: 'video',
              // 5M，文件大小限制，默认10M
              maxFileSize: 20 * 1024 * 1024,
              // 最多可上传几个文件，默认为 5
              maxNumberOfFiles: 3,
              // 选择文件时的类型限制，默认为 ['video/*'] 。如不想限制，则设置为 []
              allowedFileTypes: ['video/*'],
              // 15 秒，超时时间，默认为 30 秒
              timeout: 15 * 1000,
              headers: {
                authorization: localStorage.getItem('token'),
              },
              customInsert(res, insertFn) {
                if (res.code == 0) {
                  insertFn(res.data.url)
                }
              },
            },
          },
        },
        mode: 'default',
      }
    },
    methods: {
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
    },
    computed: {
      editorValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },
  })
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
  .editor {
    height: 500px;
    overflow-y: auto;
    width: 100%;
  }
</style>
